export const LEFT_SIDEBAR_FIXED_BOTTOM_MENU = 'left.sidebar.fixed.bottom.menu.enabled';
